<template>
  <div
    component-name="txt-scroll-cta-bath-concept"
    class="flex items-center gap-sm text-skin-base text-right"
    inert
  >
    <div class="overflow-hidden">
      <span
        ref="tpl_txt"
        class="block text-body/none"
        v-html="$t.texts.scroll_to_change_project"
      ></span>
    </div>

    <svg
      ref="tpl_svg"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 41"
      class="w-4 h-[41px] [&_*]:fill-current"
    >
      <path
        fill="#0D0D0D"
        d="M11.597 4.975a.571.571 0 1 0 .808-.808l-4-4a.571.571 0 0 0-.808 0l-4 4a.571.571 0 1 0 .808.808L8 1.38l3.596 3.595ZM8.5 14.729a.5.5 0 0 0-1 0v4a.5.5 0 1 0 1 0v-4Z"
      />
      <path
        fill="#0D0D0D"
        fill-rule="evenodd"
        d="M.204 13.676C0 14.439 0 15.369 0 17.229v6c0 1.86 0 2.79.204 3.552a6 6 0 0 0 4.243 4.243c.763.204 1.693.204 3.553.204 1.86 0 2.79 0 3.553-.204a6 6 0 0 0 4.243-4.243C16 26.018 16 25.09 16 23.23v-6c0-1.86 0-2.79-.204-3.553a6 6 0 0 0-4.243-4.243C10.79 9.229 9.86 9.229 8 9.229c-1.86 0-2.79 0-3.553.204a6 6 0 0 0-4.243 4.243ZM15 23.229v-6c0-1.925-.009-2.69-.17-3.295a5 5 0 0 0-3.536-3.535c-.604-.162-1.37-.17-3.294-.17s-2.69.008-3.294.17a5 5 0 0 0-3.536 3.535c-.161.604-.17 1.37-.17 3.295v6c0 1.924.009 2.69.17 3.294a5 5 0 0 0 3.536 3.535c.604.162 1.37.17 3.294.17s2.69-.008 3.294-.17a5 5 0 0 0 3.536-3.535c.161-.604.17-1.37.17-3.294Z"
        clip-rule="evenodd"
      />
      <path
        fill="#0D0D0D"
        d="M11.597 35.481a.572.572 0 0 1 .808.809l-4 4a.572.572 0 0 1-.808 0l-4-4a.572.572 0 0 1 .808-.809L8 39.078l3.596-3.596Z"
      />
    </svg>
  </div>
</template>

<script setup>
const tpl_svg = templateRef("tpl_svg");
const tpl_txt = templateRef("tpl_txt");

let tl;

function animateText() {
  if (tl) {
    tl.kill();
    tl = null;
  }

  tl = gsap.timeline({
    onComplete: () => {
      animateText();
    },
  });

  tl.fromTo(
    tpl_txt.value,
    { opacity: 1 },
    { duration: 0.55, opacity: 0, ease: "power1.inOut" },
    8
  );

  tl.to(tpl_svg.value, { duration: 0.75, scale: 1.1, ease: "expo.inOut" }, "<");

  tl.set(tpl_txt.value, { opacity: 1, xPercent: 130 });

  tl.to(
    tpl_txt.value,
    { duration: 1, xPercent: 0, ease: "expo.inOut" },
    "<0.1"
  );

  tl.to(tpl_svg.value, { duration: 0.75, scale: 1, ease: "expo.in" }, "<");
}

useSafeMountedEl([tpl_svg, tpl_txt], () => {
  animateText();
});

onBeforeUnmount(() => {
  if (tl) {
    tl.kill();
    tl = null;
  }
});
</script>
